export default __webpack_public_path__ + "static/media/oops.0bce70bf.png";